/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const PLAN_TYPE = 'PLAN_TYPE';
export const PLAN_TYPE_LIST = 'PLAN_TYPE_LIST';
export const REBATE_PGM_LIST = 'REBATE_PGM_LIST';
export const REBATE_PGM = 'REBATE_PGM';
export const ERROR_MSG = 'ERROR_MSG';
export const PGM_DETAIL = 'PGM_DETAIL';
export const FIRST_LOAD_REB = 'FIRST_LOAD_REB';
export const CLEAR_SEARCH_REDUX = 'CLEAR_SEARCH_REDUX';
